module.exports = __webpack_public_path__ + "static/media/icons8-push-notifications.9d3fced1.svg";